class PersonalisationNameField extends HTMLElement {
  connectedCallback() {
    this.triggerOption = (this.dataset.triggerOption || '').trim().toLowerCase();
    this.triggerValue = (this.dataset.triggerValue || '').trim().toLowerCase();
    this.isRequired = this.dataset.required === 'true';
    this.input = this.querySelector('input[name^="properties"]');

    this.onChange = (event) => {
      if (this.contains(event.target)) return;
      this.sync();
    };
    this.onVariantUpdate = () => requestAnimationFrame(() => this.sync());

    // Enforce uppercase A–Z only (we only have uppercase letter beads)
    if (this.input && this.input.dataset.lettersOnly === 'true') {
      this.onInput = () => {
        const cleaned = this.input.value.toUpperCase().replace(/[^A-Z]/g, '');
        if (this.input.value !== cleaned) {
          const pos = this.input.selectionStart;
          this.input.value = cleaned;
          try { this.input.setSelectionRange(pos - 1, pos - 1); } catch (e) {}
        }
      };
      this.input.addEventListener('input', this.onInput);
    }

    document.addEventListener('change', this.onChange);
    document.addEventListener('variant:update', this.onVariantUpdate);
    document.addEventListener('variant:selected', this.onVariantUpdate);

    requestAnimationFrame(() => this.sync());
  }

  disconnectedCallback() {
    document.removeEventListener('change', this.onChange);
    document.removeEventListener('variant:update', this.onVariantUpdate);
    document.removeEventListener('variant:selected', this.onVariantUpdate);
    if (this.input && this.onInput) this.input.removeEventListener('input', this.onInput);
  }

  getCurrentOptionValue() {
    const form = this.input?.form;
    const root = form?.closest('[id^="shopify-section"]') || document;

    for (const fs of root.querySelectorAll('fieldset')) {
      const legendText = (fs.querySelector('legend')?.textContent || '').trim().toLowerCase();
      if (!legendText.includes(this.triggerOption)) continue;

      const checked = fs.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
      if (checked) return (checked.value || '').trim().toLowerCase();

      const select = fs.querySelector('select');
      if (select) return (select.value || '').trim().toLowerCase();
    }

    for (const select of root.querySelectorAll('select[name^="options["]')) {
      const nameMatch = select.name.match(/options\[(.+?)\]/);
      if (nameMatch && nameMatch[1].trim().toLowerCase() === this.triggerOption) {
        return (select.value || '').trim().toLowerCase();
      }
    }

    return '';
  }

  sync() {
    const shouldShow = this.getCurrentOptionValue() === this.triggerValue;
    if (shouldShow) {
      this.hidden = false;
      if (this.input) {
        this.input.disabled = false;
        if (this.isRequired) this.input.required = true;
      }
    } else {
      this.hidden = true;
      if (this.input) {
        this.input.disabled = true;
        this.input.required = false;
        this.input.value = '';
      }
    }
  }
}

if (!customElements.get('personalisation-name-field')) {
  customElements.define('personalisation-name-field', PersonalisationNameField);
}
